import * as React from 'react';
import * as TipElements from './Tip.styles';
import { palette } from '../../../constants';
export var Tip = function (_a) {
    var time = _a.time, vals = _a.vals, colorScheme = _a.colorScheme, headLabel = _a.headLabel;
    if (vals.length < 1)
        return null;
    return (React.createElement(TipElements.Container, null,
        React.createElement(TipElements.Head, null,
            React.createElement(TipElements.Time, null, time),
            React.createElement(TipElements.Unit, null, headLabel !== null && headLabel !== void 0 ? headLabel : vals[0].unit)),
        React.createElement(TipElements.Body, null,
            vals.slice(0, 6).map(function (v) {
                var _a, _b;
                return (React.createElement(TipElements.Item, { key: v.key, color: (_a = colorScheme === null || colorScheme === void 0 ? void 0 : colorScheme(v.key)) !== null && _a !== void 0 ? _a : palette.blue5, isActive: v.type === 'boolean' ? Boolean(v.yVal) : true },
                    React.createElement("span", { className: "name" }, v.name),
                    v.type === 'boolean' ? (React.createElement("span", { className: "value" }, v.yVal === 1 ? 'true' : '')) : (React.createElement("span", { className: "value" },
                        typeof v.yVal === 'number'
                            ? Math.round(v.yVal * 10) / 10
                            : v.yVal,
                        ' ', (_b = v.unitSymbol) !== null && _b !== void 0 ? _b : v.unit))));
            }),
            vals.length > 7 ? (React.createElement(TipElements.Item, null,
                React.createElement("span", { className: "more-item" },
                    "+",
                    vals.length - 7,
                    " more"))) : null)));
};
//# sourceMappingURL=Tip.js.map